import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ConnexionService } from '../connexion.service';
import { FormulaireService } from '../formulaire.service';
import { environment } from '../../environments/environment';
import { AppGlobal } from '../app.global';

@Component({
  selector: 'app-connexion',
  template: ''
})

export class ConnexionComponent implements OnInit {

  constructor(private formulaireService: FormulaireService, private router: Router, private route: ActivatedRoute, private connexionService: ConnexionService, private appGlobal: AppGlobal) {}

  ngOnInit() {
    this.route.queryParamMap.subscribe(params => {
      const inCrypt = params.get('in');
      const login = params.get('login');
      const inNotCrypted = params.get('inNotCrypted');
      if ((inCrypt === undefined || inCrypt == null) && (inNotCrypted === undefined || inNotCrypted == null) && (login === undefined || login == null)) {
        this.router.navigate(['/interdit']);
      }
      const typeSouscription = params.get('typeSouscription');
      const typeSouscriptionFound = FormulaireService.typeSouscriptionList.find(t => t.code === typeSouscription);
      if (typeSouscriptionFound !== undefined) {
          this.formulaireService.setTypeSouscription(typeSouscriptionFound);
      }
      const data: any = {};
      if (inCrypt !== undefined && inCrypt != null) {
        data.inCrypt = inCrypt;
      } else if (inNotCrypted !== undefined && inNotCrypted != null) {
        data.inNotCrypted = inNotCrypted;
      }
      
      if (login !== undefined && login != null) {
        this.connexionService.setLogin(login)
        this.router.navigate(['/formulaire/pret']);
      } else {
        this.connexionService.doAuthentication(data).subscribe(
          response => {
            this.router.navigate(['/formulaire/pret']);
          },  
          err => {
            this.router.navigate(['/interdit']);
          }
        );
      }

      const distributor = params.get('distributor');
      if(distributor === 'CAFPI') {
        document.documentElement.style.setProperty('--primary-color', '#ff9b00');
        document.documentElement.style.setProperty('--primary-color-hover', '#ee8a00');
        document.documentElement.style.setProperty('--secondary-color', '#354651');
        document.documentElement.style.setProperty('--secondary-color-hover', '#243540');
        environment.primaryColor = '#ff9b00';
        environment.secondaryColor = '#354651';
        this.appGlobal.setShowHeaderAndFooter(false);
        this.appGlobal.setDistributor('CAFPI');
      }


      const token = params.get('token');
      this.appGlobal.setTokenMi(token);

      const originUrl = params.get('origin');
      this.appGlobal.setOriginUrl(originUrl);

      const profiles = params.get('profiles');
      this.appGlobal.setProfiles(profiles);

      const uniqueId = params.get('uniqueId');
      this.appGlobal.setUniqueId(uniqueId);

      const included = params.get('included');
      if(included) {
        this.appGlobal.setShowHeaderAndFooter(false);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/connexion/connexion.component.ts